import React, { type ContextType } from "react";
import { type Room } from "matrix-js-sdk/src/matrix";
import { KnownMembership } from "matrix-js-sdk/src/types";

import { _t } from "../../../../../languageHandler";
import RoomProfileSettings from "../../../room_settings/RoomProfileSettings";
import AccessibleButton, { type ButtonEvent } from "../../../elements/AccessibleButton";
import dis from "../../../../../dispatcher/dispatcher";
import MatrixClientContext from "../../../../../contexts/MatrixClientContext";
// import SettingsStore from "../../../../../settings/SettingsStore";
// import { UIFeature } from "../../../../../settings/UIFeature";
// import AliasSettings from "../../../room_settings/AliasSettings";
// import PosthogTrackers from "../../../../../PosthogTrackers";
import { SettingsSubsection } from "../../shared/SettingsSubsection";
import SettingsTab from "../SettingsTab";
import { SettingsSection } from "../../shared/SettingsSection";
// import { UrlPreviewSettings } from "../../../room_settings/UrlPreviewSettings";
import { MediaPreviewAccountSettings } from "../user/MediaPreviewAccountSettings";
import DMRoomMap from "../../../../../utils/DMRoomMap";
import { Icon as LeaveIcon } from "../../../../../../res/customIcons/leave-chat-icon.svg";
// import { Icon as DeleteIcon } from "../../../../../../res/customIcons/trash-icon.svg";


interface IProps {
    room: Room;
}

interface IState {
    isRoomPublished: boolean;
}

export default class GeneralRoomSettingsTab extends React.Component<IProps, IState> {
    public static contextType = MatrixClientContext;
    declare public context: ContextType<typeof MatrixClientContext>;

    public constructor(props: IProps) {
        super(props);

        this.state = {
            isRoomPublished: false, // loaded async
        };
    }

    private onLeaveClick = (ev: ButtonEvent): void => {
        dis.dispatch({
            action: "leave_room",
            room_id: this.props.room.roomId,
        });

        // PosthogTrackers.trackInteraction("WebRoomSettingsLeaveButton", ev);
    };

    public render(): React.ReactNode {
        // const client = this.context;
        const room = this.props.room;
        const isDm = Boolean(DMRoomMap.shared().getUserIdForRoomId(room.roomId));
        // const canSetAliases = true; // Previously, we arbitrarily only allowed admins to do this
        // const canSetCanonical = room.currentState.mayClientSendStateEvent("m.room.canonical_alias", client);
        // const canonicalAliasEv = room.currentState.getStateEvents("m.room.canonical_alias", "") ?? undefined;

        // const urlPreviewSettings = SettingsStore.getValue(UIFeature.URLPreviews) ? (
        //     <UrlPreviewSettings room={room} />
        // ) : null;

        let leaveSection;
        if (room.getMyMembership() === KnownMembership.Join) {
            leaveSection = (
                <SettingsSubsection /*heading={_t("action.leave_room")}*/>
                    <AccessibleButton kind="danger" onClick={this.onLeaveClick}>
                        {isDm ? (
                            <>
                                {/* <DeleteIcon className="mx_SidebarUserSettingsTab_icon" width="24" height="24" /> */}
                                <LeaveIcon className="mx_SidebarUserSettingsTab_icon" width="24" height="24" />
                                {_t("action.delete_chat")}
                            </>
                        ) : (
                            <>
                                <LeaveIcon className="mx_SidebarUserSettingsTab_icon" width="24" height="24" />
                                {_t("action.leave_chat")}
                            </>
                        )}
                    </AccessibleButton>
                </SettingsSubsection>
            );
        }

        return (
            <SettingsTab data-testid="General">

                {!isDm && <SettingsSection heading={_t("common.general")}>
                    <RoomProfileSettings roomId={room.roomId} />
                </SettingsSection>}

                {/* <SettingsSection heading={_t("room_settings.general.aliases_section")}>
                    <AliasSettings
                        roomId={room.roomId}
                        canSetCanonicalAlias={canSetCanonical}
                        canSetAliases={canSetAliases}
                        canonicalAliasEvent={canonicalAliasEv}
                    />
                </SettingsSection> */}

                <SettingsSection /* heading={_t("room_settings.general.other_section")}*/>
                    {/* {urlPreviewSettings} */}
                    <SettingsSubsection heading={_t("common.moderation_and_safety")} legacy={false}>
                        <MediaPreviewAccountSettings roomId={room.roomId} />
                    </SettingsSubsection>
                    {leaveSection}
                </SettingsSection>
            </SettingsTab>
        );
    }
}
